module.exports = __webpack_public_path__ + "img/Synth.d6991a8c.png";